export const PRODUCT_DETAILS_PANEL_MODE = {
  product: 'product',
  aggregated: 'aggregated',
};

export function getProductDetailsPanelMode({
  isMainApp,
  hasAssets,
  productSelectionCount,
  activeProduct,
  isBulkMediaView,
  isPreviewPanel,
}) {
  if (!isMainApp) return null;

  // The opened asset owns the preview sidebar. A product still selected in the
  // catalog must not replace that asset's details.
  if (isPreviewPanel && hasAssets) return null;

  if (productSelectionCount >= 2) {
    return PRODUCT_DETAILS_PANEL_MODE.aggregated;
  }

  if (productSelectionCount === 1) {
    return PRODUCT_DETAILS_PANEL_MODE.product;
  }

  if (isBulkMediaView) return PRODUCT_DETAILS_PANEL_MODE.aggregated;
  if (hasAssets) return null;

  if (activeProduct) {
    return PRODUCT_DETAILS_PANEL_MODE.product;
  }

  return null;
}

export default getProductDetailsPanelMode;
